export const account_home_personal_info = {
  personal_information: "Personal Information",
  personal_information_blurb:
    "The name, email, and phone number we associate with your sign-in. Updates are handled through our secure identity provider.",
  personal_information_edit: "Edit Name & Phone",
  personal_information_change_email: "Change Email",
  personal_information_name_label: "Name",
  personal_information_email_label: "Email",
  personal_information_phone_label: "Phone",
  personal_information_unset: "—",
} as const;
